module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"sizeError":"Email content is too large"}}')
  delete Component.options._Ctor
}
